module.exports = __webpack_public_path__ + "static/img/GBZ805-FCM-359-BB-2.b9cf4da.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2027/GBZ805-FCM-359-BB-2.jpg
// module id = azYD
// module chunks = 0